import React, { useState } from 'react';
import { captureScreenshot } from '../../components/common/captureScreenshot';
import { portfolioItems } from '../../data/portfolio';
import { Card, Button, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import "./MenuPage.css"

const TITLE = "Portfolio";

const MenuPage: React.FC = () => {
    const [screenshots, setScreenshots] = useState<{ [key: number]: string }>({});
    const [likes, setLikes] = useState<{ [key: number]: number }>({});

    /**
     * 「良いね！」ボタンをクリックしたときの処理
     */
    const handleLike = (id: number) => {
        setLikes((prev) => ({ ...prev, [id]: (prev[id] || 0) + 1 }));
    };

    /**
     * 全ポートフォリオのスクリーンショットを生成
     */
    const generateScreenshots = async () => {
        for (const item of portfolioItems) {
            if (item.component) {
                const screenshot = await captureScreenshot(item.component);
                if (screenshot) {
                    setScreenshots((prev) => ({ ...prev, [item.id]: screenshot }));
                }
            }
        }
    };

    React.useEffect(() => {
        generateScreenshots();
    }, []);

    return (
        <div className="MenuPageRoot container mt-5">
            <h1 className="text-center mb-4">{TITLE}</h1>
            <Row>
                {portfolioItems.map((item, index) => (
                    <Col key={item.id} xs={12} sm={6} md={4} className="mb-4">
                        {/* カードアニメーション */}
                        <motion.div
                            initial={{ opacity: 0, scale: 0.5, rotate: 45 }}
                            animate={{ opacity: 1, scale: 1, rotate: 0 }}
                            transition={{
                                delay: index * 0.2,
                                duration: 0.8,
                                ease: 'easeOut',
                            }}
                            whileHover={{
                                scale: 1.1,
                                boxShadow: "0px 0px 20px rgba(154, 255, 0, 1)", // 黄緑色のグロー効果
                                transition: { duration: 0.3 },
                            }}
                            style={{
                                background: "radial-gradient(circle, rgba(173,255,47,1) 0%, rgba(124,252,0,1) 50%, rgba(50,205,50,1) 100%)", // 黄緑系グラデーション
                                padding: "10px",
                                borderRadius: "15px",
                            }}
                        >
                            <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>

                                {/* カードイメージ */}
                                {screenshots[item.id] ? (
                                    <Card.Img
                                        variant="top"
                                        src={screenshots[item.id]}
                                        alt={item.title}
                                        style={{ height: '150px', objectFit: 'cover', borderRadius: '10px' }}
                                    />
                                ) : (
                                    <Card.Img
                                        variant="top"
                                        src="https://via.placeholder.com/300x150?text=Loading..."
                                        alt="Loading..."
                                        style={{ height: '150px', objectFit: 'cover', borderRadius: '10px' }}
                                    />
                                )}

                                {/* カードヘッダー */}
                                <Card.Header className="bg-primary text-white text-center">
                                    {item.title}
                                </Card.Header>

                                {/* カードボディ */}
                                <Card.Body>
                                    <Card.Text>{item.description}</Card.Text>
                                </Card.Body>

                                {/* カードフッター */}
                                <Card.Footer className="d-flex justify-content-between align-items-center">
                                    {/* ボタン */}
                                    <Button variant="primary" href={item.link}>
                                        View {item.title}
                                    </Button>
                                    {/* 良いね！ボタン */}
                                    <motion.button
                                        whileHover={{
                                            scale: 1.1,
                                            boxShadow: "0 0 15px rgba(154, 255, 0, 1)",
                                        }}
                                        whileTap={{
                                            scale: 1.2,
                                            boxShadow: "0 0 25px rgba(154, 255, 0, 0.8)",
                                        }}
                                        transition={{
                                            duration: 0.3,
                                            ease: "easeInOut",
                                        }}
                                        style={{
                                            width: "60px", // ボタンの幅を少し広げる
                                            height: "60px",
                                            borderRadius: "50%",
                                            border: "2px solid rgba(154, 255, 0, 0.8)",
                                            backgroundColor: "rgba(0, 0, 0, 0.9)",
                                            color: "white",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            outline: "none",
                                            cursor: "pointer",
                                            position: "relative",
                                        }}
                                        onClick={() => handleLike(item.id)}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "5px", // アイコンと数字の間隔を調整
                                                flexWrap: "nowrap", // 数字が改行されないように設定
                                            }}
                                        >
                                            <span role="img" aria-label="thumbs up">
                                                👍
                                            </span>
                                            <span
                                                style={{
                                                    minWidth: "25px", // 数字部分の最小幅を確保
                                                    textAlign: "center", // 数字を中央に揃える
                                                    whiteSpace: "nowrap", // 改行を防止
                                                }}
                                            >
                                                {likes[item.id] || 0}
                                            </span>
                                        </div>
                                    </motion.button>
                                </Card.Footer>
                            </Card>
                        </motion.div>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default MenuPage;
